<script>


    export let tokenId;
    let tokenIndex;


    import {
        solve,
        _pending as pending,
        _requested as requested

    } from "../stores/contractTreasure";

    let isPending, isRequested;


    $:{
        isPending =   $pending.solve[tokenId];
        isRequested = $requested.solve[tokenId];


        tokenIndex = tokenId - 1;
        password = passwords[tokenIndex];
    }

    let password;
    let passwords = [
        "apple",
        "orange",
        "pear",
        "banana",
    ];

    let suppliedAnswer = "";
    async function doClaim(){
        if(suppliedAnswer !== password){
            alert("Nope, try: "+password);
            return;
        }

        await solve(tokenId,suppliedAnswer);
    }
</script>

<style>
    .solver{
        display: flex;
        flex-direction: column;
    }
</style>

<div class="solver">
    <h3>Button #{tokenId}</h3>
    <div>Clue: type the word "{password}"</div>
    {#if isRequested}
        <div>requested...</div>
    {:else if isPending}
        <div>pending...</div>
    {:else}
        <div><input bind:value={suppliedAnswer}/><button on:click={doClaim}>Claim Prize</button></div>

    {/if}
</div>